import {
  pageState,
  modalListFilterState
} from 'Pages/ScheduledSendings/recoil/state/page'
import {
  calendarState,
  timelineState
} from 'Pages/ScheduledSendings/recoil/state/calendar'

import { logAppError, logAppInfo } from 'Helpers/logger'
import getIntl from 'Helpers/intl'

import {
  fetchSendings,
  evalApplyDate,
  getTodayDate,
  stopSending,
  getAllLists,
  getSendingSegmentation,
  simulateSending,
  setSendingScheduled,
  updateSendingItem
} from '../actions/actions'

import {
  modalSendingSegmentationState,
  modalStopCampaignState,
  modalStopSendingState,
  modalScheduleSendingState
} from '../state/modals'
import { pendoTrack } from 'Helpers/pendoTracking'
import { toastState } from '../../../../recoil'

export const fetchScheduledCallback = ({ set, snapshot }) => async ({
  idLists,
  calendarAction
} = {}) => {
  set(pageState, prev => ({ ...prev, loading: true }))

  try {
    const { month, lists } = await snapshot.getPromise(calendarState)
    const { day } = await snapshot.getPromise(timelineState)
    const applyList = idLists || lists
    // giorno corrente
    const today = getTodayDate()
    // costruisce il calendario
    const {
      dateFrom,
      dateTo,
      days,
      currentMonth,
      canPrev,
      timezoneFormatted
    } = evalApplyDate(month, today, calendarAction)

    set(calendarState, prev => ({
      ...prev,
      lists: applyList,
      month: currentMonth,
      //  date: baseDate,
      days,
      canPrev,
      timezoneFormatted
    }))

    const sendings = await fetchSendings(
      applyList,
      dateFrom.toISOString(),
      dateTo.toISOString()
    )

    set(calendarState, prev => ({
      ...prev,
      sendings,
      sendingsLoaded: true
    }))

    // filtra per il giorno corrente
    if (day === undefined || day === today) {
      const daySendings = sendings
        .filter(({ dateFormatted }) => dateFormatted === today)
        .sort(({ timeFormatted: a }, { timeFormatted: b }) =>
          a < b ? -1 : a > b ? 1 : 0
        )
      set(timelineState, {
        day: today,
        sendings: daySendings.map(o => ({ ...o, expanded: false }))
      })
    } else {
      const dateSendings = sendings
        .filter(({ dateFormatted }) => dateFormatted === day)
        .sort(({ timeFormatted: a }, { timeFormatted: b }) =>
          a < b ? -1 : a > b ? 1 : 0
        )
      set(timelineState, {
        day,
        sendings: dateSendings.map(o => ({ ...o, expanded: false }))
      })
    }
  } catch (error) {
    console.error('### error', error)
    logAppError({
      appError: error
    })
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }

  set(pageState, prev => ({ ...prev, loading: false }))
}

export const fetchListsCallback = ({ set }) => async () => {
  try {
    const lists = await getAllLists()
    set(pageState, prev => ({ ...prev, allLists: lists }))
  } catch (error) {
    console.error('### error', error)
    logAppError({
      appError: error
    })
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }
}

export const openModalListFilterCallback = ({ set, snapshot }) => async () => {
  const { lists } = await snapshot.getPromise(calendarState)
  set(modalListFilterState, prev => ({
    ...prev,
    value: [...lists],
    show: true
  }))
}

export const selectDayCallback = ({ set, snapshot }) => async (
  date,
  idSending
) => {
  const { sendings } = await snapshot.getPromise(calendarState)
  const daySendings = sendings
    .filter(({ dateFormatted }) => dateFormatted === date)
    .sort(({ timeFormatted: a }, { timeFormatted: b }) =>
      a < b ? -1 : a > b ? 1 : 0
    )

  set(calendarState, prev => ({ ...prev, selectedDay: date }))

  set(timelineState, {
    day: date,
    sendings: daySendings.map(o => ({ ...o, expanded: o.id === idSending }))
  })
}

export const toggleExpandCallback = ({ set, snapshot }) => async idSending => {
  set(timelineState, ({ sendings, ...prev }) => ({
    ...prev,
    sendings: sendings.map(({ id, expanded, ...rest }) => ({
      ...rest,
      id,
      expanded: id === idSending ? !expanded : expanded
    }))
  }))
}

export const stopSendingConfirmCallback = ({
  set,
  reset,
  snapshot
}) => async idSending => {
  set(pageState, prev => ({ ...prev, loading: true }))
  try {
    logAppInfo({
      Component: 'ScheduledSendings',
      Method: 'stopSendingConfirmCallback',
      Message: 'Inizio elimina coda',
      Data: JSON.stringify({ idSending })
    })

    await stopSending(idSending)

    logAppInfo({
      Component: 'ScheduledSendings',
      Method: 'stopSendingConfirmCallback',
      Message: 'Fine elimina coda',
      Data: JSON.stringify({ idSending })
    })

    set(calendarState, prev => ({
      ...prev,
      sendings: prev.sendings.filter(e => e.id !== idSending),
      sendingsLoaded: true
    }))

    set(timelineState, prev => ({
      ...prev,
      sendings: prev.sendings.filter(e => e.id !== idSending),
      sendingsLoaded: true
    }))

    set(toastState, {
      message: getIntl().formatMessage({
        id: 'Load.ScheduledMailing.StopSucces'
      }),
      key: 'ScheduledMailingSendingStateSuccessfulCancelled'
    })

    reset(modalStopSendingState)
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'ScheduledSendings',
      Method: 'stopSendingConfirmCallback',
      Message: 'Errore in elimina coda',
      Data: JSON.stringify({ idSending })
    })
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }
  set(pageState, prev => ({ ...prev, loading: false }))
}

export const sendingSegmentationCallback = ({ set }) => async idSending => {
  set(modalSendingSegmentationState, prev => ({
    ...prev,
    show: true,
    loading: true
  }))

  try {
    const {
      groups,
      excludedGroups,
      filters,
      idMessage,
      stopped,
      ...rest
    } = await getSendingSegmentation(idSending)

    const section = groups.length
      ? 'groups'
      : excludedGroups.length
      ? 'excludedGroups'
      : filters.length
      ? 'filters'
      : 'undefined'

    set(modalSendingSegmentationState, prev => ({
      ...prev,
      loading: false,
      groups,
      excludedGroups,
      filters,
      section,
      idSending,
      idMessage,
      ...rest
    }))

    pendoTrack('Sending - Modal segmentation - impression', {
      IdMessage: idMessage,
      SegemtationApplied: section ? 'True' : 'False',
      IsStopped: stopped ? 'True' : 'False'
    })
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'ScheduledSendings',
      Method: 'sendingSegmentationCallback',
      Message: 'Errore in apertura modale di segmentazione',
      Data: JSON.stringify({ idSending })
    })

    set(modalSendingSegmentationState, prev => ({
      ...prev,
      loading: false,
      idSending,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }
}

export const sendingSegmentationSimulateCallback = ({
  set,
  snapshot
}) => async () => {
  const {
    idMessage,
    idSending,
    groups,
    excludedGroups,
    filters,
    queued
  } = await snapshot.getPromise(modalSendingSegmentationState)

  set(modalSendingSegmentationState, prev => ({
    ...prev,
    simulationLoading: true
  }))

  try {
    const { ToBeQueued } = await simulateSending(
      idSending,
      groups,
      excludedGroups,
      filters
    )

    const simulationDiff = ToBeQueued - queued

    set(modalSendingSegmentationState, prev => ({
      ...prev,
      simulationLoading: false,
      simulationLoaded: true,
      simulationResult: ToBeQueued,
      simulationDiff
    }))

    pendoTrack('Sending - Modal segmentation - result recipients', {
      IdMessage: idMessage,
      IsTheSame: simulationDiff === 0 ? 'True' : 'False',
      Result: simulationDiff
    })
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'ScheduledSendings',
      Method: 'sendingSegmentationSimulateCallback',
      Message: 'Errore in simulazione da modale di segmentazione',
      Data: JSON.stringify({ idSending })
    })

    set(modalSendingSegmentationState, prev => ({
      ...prev,
      simulationLoading: false,
      simulationLoaded: true,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }
}

export const openCampaignModaleCallback = ({
  set,
  snapshot
}) => async idSending => {
  set(pageState, prev => ({ ...prev, loading: true }))
  try {
    const objItem = await snapshot.getPromise(timelineState)
    if (objItem) {
      const item = objItem.sendings.find(o => o.id === idSending)
      set(modalStopCampaignState, {
        show: true,
        idSending,
        idList: item.idList,
        idSource: item.campaign.IdSource
      })
    }
  } catch (error) {
    logAppError({ appError: error })
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }
  set(pageState, prev => ({ ...prev, loading: false }))
}

export const stopSendingCampaignConfirmCallback = ({
  set,
  reset,
  snapshot
}) => async idSending => {
  set(pageState, prev => ({ ...prev, loading: true }))
  try {
    logAppInfo({
      Component: 'ScheduledSendings',
      Method: 'stopSendingConfirmCallback',
      Message: 'Inizio elimina coda',
      Data: JSON.stringify({ idSending })
    })

    await stopSending(idSending)

    logAppInfo({
      Component: 'ScheduledSendings',
      Method: 'stopSendingConfirmCallback',
      Message: 'Fine elimina coda',
      Data: JSON.stringify({ idSending })
    })

    set(calendarState, prev => ({
      ...prev,
      sendings: prev.sendings.filter(e => e.id !== idSending),
      sendingsLoaded: true
    }))

    set(timelineState, prev => ({
      ...prev,
      sendings: prev.sendings.filter(e => e.id !== idSending),
      sendingsLoaded: true
    }))

    set(toastState, {
      message: getIntl().formatMessage({
        id: 'Load.ScheduledMailing.StopSucces'
      }),
      key: 'ScheduledMailingCampaignStateSuccessfulCancelled'
    })

    reset(modalStopCampaignState)
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'ScheduledSendings',
      Method: 'stopSendingConfirmCallback',
      Message: 'Errore in elimina coda',
      Data: JSON.stringify({ idSending })
    })
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }
  set(pageState, prev => ({ ...prev, loading: false }))
}

export const openRescheduleModaleCallback = ({
  set,
  snapshot
}) => async idSending => {
  const objItem = await snapshot.getPromise(calendarState)

  if (objItem) {
    const item = objItem.sendings.find(e => e.id === idSending)
    if (item) {
      set(modalScheduleSendingState, prev => ({
        ...prev,
        startDate: item.date,
        timeZoneCode: item.timezone,
        idSending,
        show: true
      }))
    }
  }
}

export const sendingScheduleSetScheduleCallback = ({
  set,
  reset,
  snapshot
}) => async (idSending, dateStart, timeZoneCode) => {
  if (!idSending) {
    return
  }

  set(modalScheduleSendingState, prev => ({
    ...prev,
    sending: true
  }))
  set(pageState, prev => ({ ...prev, loading: true }))
  const { day: date } = await snapshot.getPromise(timelineState)
  try {
    logAppInfo({
      Component: 'ScheduledSendings',
      Method: 'sendingScheduleSetScheduleCallback',
      Message: 'Inizio imposta schedulazione invio',
      Data: JSON.stringify({ idSending, dateStart, timeZoneCode })
    })

    await setSendingScheduled(idSending, dateStart, timeZoneCode)

    logAppInfo({
      Component: 'ScheduledSendings',
      Method: 'sendingScheduleSetScheduleCallback',
      Message: 'Fine imposta schedulazione invio',
      Data: JSON.stringify({ idSending, dateStart, timeZoneCode })
    })

    set(calendarState, ({ sendings, ...prev }) => ({
      ...prev,
      sendings: sendings.map(o =>
        o.id === idSending ? updateSendingItem(o, dateStart, timeZoneCode) : o
      )
    }))

    set(timelineState, ({ sendings, ...prev }) => ({
      ...prev,
      sendings: sendings
        .map(o =>
          o.id === idSending ? updateSendingItem(o, dateStart, timeZoneCode) : o
        )
        .filter(({ dateFormatted }) => dateFormatted === date)
        .sort(({ timeFormatted: a }, { timeFormatted: b }) =>
          a < b ? -1 : a > b ? 1 : 0
        )
    }))

    set(toastState, {
      message: getIntl().formatMessage({
        id: 'Load.ScheduledMailing.ScheduledSucces'
      }),
      key: 'ScheduledMailingScheduleSendingSuccessfulScheduled'
    })

    reset(modalScheduleSendingState)
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'CampaignsSendStatus',
      Method: 'sendingScheduleSetScheduleCallback',
      Message: 'Errore imposta schedulazione invio',
      Data: JSON.stringify({ idSending, dateStart, timeZoneCode })
    })

    set(modalScheduleSendingState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }
  // va comunque fatto il set perchè se c'è un errore non verrebbe chiamato il reset
  set(modalScheduleSendingState, prev => ({
    ...prev,
    sending: false
  }))
  set(pageState, prev => ({ ...prev, loading: false }))
}
